// Login Device module - English
export default {
  tabs: {
    summary: "Login IP Summary",
    details: "Login IP Details",
    device: "Device Details",
  },
  common: {
    totalPrefix: "Total ",
    totalSuffix: " items",
    download: "Download",
    downloadFilename: "Details",
    loading: "Loading...",
    empty: "No Data",
  },
  placeholders: {
    inputIpLocation: "Enter IP location",
  },
  columns: {
    ipAddress: "IP Address",
    ipLocation: "IP Location",
    loginCount: "Login Count",
    lastLoginTime: "Last Login Time",
    port: "Port",
    loginTime: "Login Time",
    loginWay: "Login Method",
    deviceName: "Device Name",
    deviceId: "Device ID (UUID)",
    client: "Client",
    imei: "IMEI",
    mac: "MAC",
  },
};
